__turbopack_context__.v({
  "container": "commonTableModule-module-scss-module__hVR2Na__container",
});
